// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"fda56b58","146":"72abb734","250":"2a65fa95","315":"4247e360","320":"e6d1d0e8","373":"cd8c6319","437":"f11f0241","544":"cb83bb5d","558":"c55fd5d9","573":"3478fc05","601":"d5544e6a","631":"6797c63a","695":"131e0e4c","731":"5f96add7"}[chunkId] + ".chunk.js";
};